import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "users-list-tab" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = { class: "tab-header-meta" }
const _hoisted_4 = { class: "tab-count" }
const _hoisted_5 = {
  key: 0,
  class: "header-actions"
}
const _hoisted_6 = {
  key: 0,
  class: "form-panel"
}
const _hoisted_7 = { class: "form-panel-header" }
const _hoisted_8 = { class: "form-section" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = { class: "access-cards" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "access-card-label" }
const _hoisted_14 = { class: "form-section" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 0,
  class: "invite-success"
}
const _hoisted_17 = { class: "form-actions" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 1,
  class: "field-error form-error"
}
const _hoisted_20 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_21 = {
  key: 2,
  class: "user-cards"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "avatar-initials"
}
const _hoisted_24 = { class: "user-info" }
const _hoisted_25 = { class: "user-name" }
const _hoisted_26 = { class: "user-meta" }
const _hoisted_27 = { class: "user-username" }
const _hoisted_28 = {
  key: 0,
  class: "role-chip"
}
const _hoisted_29 = { class: "user-access" }
const _hoisted_30 = {
  key: 0,
  class: "user-actions"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["disabled", "onClick"]
const _hoisted_33 = {
  key: 2,
  class: "form-panel"
}
const _hoisted_34 = { class: "form-panel-header" }
const _hoisted_35 = { class: "form-panel-title" }
const _hoisted_36 = { class: "form-section" }
const _hoisted_37 = { class: "field-row" }
const _hoisted_38 = { class: "field" }
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "field" }
const _hoisted_41 = ["value", "disabled"]
const _hoisted_42 = { class: "field-row" }
const _hoisted_43 = { class: "field" }
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "field" }
const _hoisted_46 = {
  class: "field-label",
  for: "acc-birth"
}
const _hoisted_47 = { class: "field-hint" }
const _hoisted_48 = ["value", "min", "max", "required"]
const _hoisted_49 = { class: "form-section" }
const _hoisted_50 = { class: "field-row" }
const _hoisted_51 = { class: "field" }
const _hoisted_52 = ["value"]
const _hoisted_53 = ["value"]
const _hoisted_54 = {
  key: 0,
  class: "field"
}
const _hoisted_55 = { class: "access-cards" }
const _hoisted_56 = ["value", "checked", "onChange"]
const _hoisted_57 = { class: "access-card-label" }
const _hoisted_58 = { class: "field" }
const _hoisted_59 = { class: "password-header" }
const _hoisted_60 = {
  class: "field-label",
  for: "acc-password"
}
const _hoisted_61 = {
  key: 0,
  class: "field-hint"
}
const _hoisted_62 = { class: "password-input-wrap" }
const _hoisted_63 = ["value", "type"]
const _hoisted_64 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_65 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_66 = {
  key: 0,
  class: "field-error"
}
const _hoisted_67 = { class: "form-section" }
const _hoisted_68 = {
  key: 0,
  class: "sub-chips"
}
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 1,
  class: "sub-add-row"
}
const _hoisted_71 = ["value"]
const _hoisted_72 = {
  key: 2,
  class: "empty-sub-msg"
}
const _hoisted_73 = { class: "form-actions" }
const _hoisted_74 = {
  key: 0,
  class: "field-error form-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonList = _resolveComponent("SkeletonList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.accounts.length) + " " + _toDisplayString(_ctx.accounts.length === 1 ? 'usuário' : 'usuários'), 1)
      ]),
      (!_ctx.isAnalyst && !_ctx.showAccountForm && !_ctx.showInviteForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn-invite",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showInviteForm = true))
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none"
              }, [
                _createElementVNode("rect", {
                  x: "1",
                  y: "2",
                  width: "12",
                  height: "9",
                  rx: "1.5",
                  stroke: "currentColor",
                  "stroke-width": "1.4"
                }),
                _createElementVNode("path", {
                  d: "M1 4l6 4 6-4",
                  stroke: "currentColor",
                  "stroke-width": "1.4"
                })
              ], -1),
              _createTextVNode(" Convidar ", -1)
            ]))]),
            _createElementVNode("button", {
              class: "btn-new",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('open-account-form')))
            }, [...(_cache[20] || (_cache[20] = [
              _createElementVNode("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  d: "M7 1v12M1 7h12",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round"
                })
              ], -1),
              _createTextVNode(" Novo usuário ", -1)
            ]))])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showInviteForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "form-panel-title" }, "Convidar para o sistema", -1)),
            _createElementVNode("button", {
              class: "btn-cancel-link",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeInviteForm && _ctx.closeInviteForm(...args)))
            }, "Cancelar")
          ]),
          _cache[29] || (_cache[29] = _createElementVNode("p", { class: "invite-desc" }, "O usuário receberá um e-mail com um link para criar a própria conta.", -1)),
          _createElementVNode("fieldset", _hoisted_8, [
            _cache[22] || (_cache[22] = _createElementVNode("legend", { class: "form-section-label" }, "E-mail", -1)),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inviteForm.email) = $event)),
                type: "email",
                placeholder: "usuario@empresa.com"
              }, null, 512), [
                [_vModelText, _ctx.inviteForm.email]
              ])
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_10, [
            _cache[23] || (_cache[23] = _createElementVNode("legend", { class: "form-section-label" }, "Nível de acesso", -1)),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessOptions, (opt) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: opt.value,
                  class: _normalizeClass(["access-card", { selected: _ctx.inviteForm.role === opt.value }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "inv-access",
                    value: opt.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inviteForm.role) = $event))
                  }, null, 8, _hoisted_12), [
                    [_vModelRadio, _ctx.inviteForm.role]
                  ]),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(opt.label), 1)
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_14, [
            _cache[25] || (_cache[25] = _createElementVNode("legend", { class: "form-section-label" }, "Cargo (opcional)", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "field-input field-select",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inviteForm.roleId) = $event))
            }, [
              _cache[24] || (_cache[24] = _createElementVNode("option", { value: "" }, "Sem cargo", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: role.id,
                  value: role.id
                }, _toDisplayString(role.name), 9, _hoisted_15))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.inviteForm.roleId]
            ])
          ]),
          (_ctx.inviteSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _cache[26] || (_cache[26] = _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 16 16",
                  fill: "none"
                }, [
                  _createElementVNode("circle", {
                    cx: "8",
                    cy: "8",
                    r: "7",
                    stroke: "#22c55e",
                    "stroke-width": "1.4"
                  }),
                  _createElementVNode("path", {
                    d: "M5 8l2 2 4-4",
                    stroke: "#22c55e",
                    "stroke-width": "1.4",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)),
                _cache[27] || (_cache[27] = _createTextVNode(" Convite enviado para ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.inviteForm.email), 1),
                _cache[28] || (_cache[28] = _createTextVNode("! ", -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "btn-primary-action",
              type: "button",
              disabled: _ctx.inviteLoading,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sendInvite && _ctx.sendInvite(...args)))
            }, _toDisplayString(_ctx.inviteLoading ? 'Enviando…' : 'Enviar convite'), 9, _hoisted_18),
            _createElementVNode("button", {
              class: "btn-ghost-action",
              type: "button",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeInviteForm && _ctx.closeInviteForm(...args)))
            }, "Cancelar")
          ]),
          (_ctx.inviteError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.inviteError), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.showAccountForm)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.showSkeleton)
            ? (_openBlock(), _createBlock(_component_SkeletonList, {
                key: 0,
                variant: "row",
                count: 5,
                columns: [10, 30, 20, 15]
              }))
            : (_ctx.accounts.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("svg", {
                    width: "40",
                    height: "40",
                    viewBox: "0 0 40 40",
                    fill: "none"
                  }, [
                    _createElementVNode("circle", {
                      cx: "20",
                      cy: "14",
                      r: "7",
                      stroke: "var(--ink-muted,#888)",
                      "stroke-width": "2"
                    }),
                    _createElementVNode("path", {
                      d: "M6 36c0-7.732 6.268-14 14-14s14 6.268 14 14",
                      stroke: "var(--ink-muted,#888)",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    })
                  ], -1),
                  _createElementVNode("p", null, "Nenhum usuário cadastrado.", -1),
                  _createElementVNode("p", { class: "empty-sub" }, "Clique em \"Novo usuário\" para adicionar o primeiro membro.", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (acc) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: acc.username,
                      class: "user-card"
                    }, [
                      _createElementVNode("div", {
                        class: "user-avatar",
                        style: _normalizeStyle({ background: _ctx.avatarColor(acc.name) })
                      }, [
                        (acc.avatar)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.$resolveUrl(acc.avatar),
                              alt: "perfil",
                              class: "avatar-img"
                            }, null, 8, _hoisted_22))
                          : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.initials(acc.name)), 1))
                      ], 4),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(acc.name), 1),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, "@" + _toDisplayString(acc.username), 1),
                          (_ctx.roleLabel(acc.roleId) !== 'Sem cargo')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.roleLabel(acc.roleId)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["access-badge", 'access-' + acc.role])
                        }, _toDisplayString(_ctx.accessLabel(acc.role)), 3)
                      ]),
                      (!_ctx.isAnalyst)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("button", {
                              class: "action-btn",
                              type: "button",
                              title: "Editar",
                              onClick: ($event: any) => (_ctx.$emit('edit-account', acc))
                            }, [...(_cache[31] || (_cache[31] = [
                              _createElementVNode("svg", {
                                width: "15",
                                height: "15",
                                viewBox: "0 0 15 15",
                                fill: "none"
                              }, [
                                _createElementVNode("path", {
                                  d: "M10.5 2.5l2 2-8 8H2.5v-2l8-8z",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4",
                                  "stroke-linejoin": "round"
                                })
                              ], -1)
                            ]))], 8, _hoisted_31),
                            _createElementVNode("button", {
                              class: "action-btn action-btn--danger",
                              type: "button",
                              title: "Apagar",
                              disabled: acc.uid === _ctx.currentUid,
                              onClick: ($event: any) => (_ctx.$emit('delete-account', acc))
                            }, [...(_cache[32] || (_cache[32] = [
                              _createElementVNode("svg", {
                                width: "15",
                                height: "15",
                                viewBox: "0 0 15 15",
                                fill: "none"
                              }, [
                                _createElementVNode("path", {
                                  d: "M3 4h9M6 4V2.5h3V4M5.5 4v7.5h4V4",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                })
                              ], -1)
                            ]))], 8, _hoisted_32)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.showAccountForm && !_ctx.isAnalyst)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("h3", _hoisted_35, _toDisplayString(_ctx.accountForm.isEditing ? 'Editar usuário' : 'Novo usuário'), 1),
            _createElementVNode("button", {
              class: "btn-cancel-link",
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close-account-form')))
            }, "Cancelar")
          ]),
          _createElementVNode("fieldset", _hoisted_36, [
            _cache[37] || (_cache[37] = _createElementVNode("legend", { class: "form-section-label" }, "Identidade", -1)),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _cache[33] || (_cache[33] = _createElementVNode("label", {
                  class: "field-label",
                  for: "acc-name"
                }, "Nome completo", -1)),
                _createElementVNode("input", {
                  id: "acc-name",
                  class: "field-input",
                  value: _ctx.accountForm.name,
                  type: "text",
                  placeholder: "Ex: João Silva",
                  onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateField('name', ($event.target as HTMLInputElement).value)))
                }, null, 40, _hoisted_39)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[34] || (_cache[34] = _createElementVNode("label", {
                  class: "field-label",
                  for: "acc-username"
                }, "Username", -1)),
                _createElementVNode("input", {
                  id: "acc-username",
                  class: "field-input",
                  value: _ctx.accountForm.username,
                  type: "text",
                  placeholder: "joaosilva",
                  disabled: _ctx.accountForm.isEditing,
                  onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateField('username', ($event.target as HTMLInputElement).value)))
                }, null, 40, _hoisted_41)
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _cache[35] || (_cache[35] = _createElementVNode("label", {
                  class: "field-label",
                  for: "acc-email"
                }, [
                  _createTextVNode("E-mail "),
                  _createElementVNode("span", { class: "field-hint" }, "(recuperação de senha)")
                ], -1)),
                _createElementVNode("input", {
                  id: "acc-email",
                  class: "field-input",
                  value: _ctx.accountForm.email,
                  type: "email",
                  placeholder: "joao@empresa.com",
                  onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateField('email', ($event.target as HTMLInputElement).value)))
                }, null, 40, _hoisted_44)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("label", _hoisted_46, [
                  _cache[36] || (_cache[36] = _createTextVNode(" Data de nascimento ", -1)),
                  _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.accountForm.isEditing ? '(deixe em branco para manter)' : '(maior de 18 anos)'), 1)
                ]),
                _createElementVNode("input", {
                  id: "acc-birth",
                  class: "field-input",
                  value: _ctx.accountForm.birthDate,
                  type: "date",
                  min: _ctx.MIN_BIRTH_DATE,
                  max: _ctx.maxBirthDate(),
                  required: !_ctx.accountForm.isEditing,
                  onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateField('birthDate', ($event.target as HTMLInputElement).value)))
                }, null, 40, _hoisted_48)
              ])
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_49, [
            _cache[43] || (_cache[43] = _createElementVNode("legend", { class: "form-section-label" }, "Acesso", -1)),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _cache[39] || (_cache[39] = _createElementVNode("label", {
                  class: "field-label",
                  for: "acc-role-id"
                }, "Cargo", -1)),
                _createElementVNode("select", {
                  id: "acc-role-id",
                  class: "field-input field-select",
                  value: _ctx.accountForm.roleId,
                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateField('roleId', ($event.target as HTMLSelectElement).value)))
                }, [
                  _cache[38] || (_cache[38] = _createElementVNode("option", { value: "" }, "Sem cargo", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: role.id,
                      value: role.id
                    }, _toDisplayString(role.name), 9, _hoisted_53))
                  }), 128))
                ], 40, _hoisted_52)
              ]),
              (_ctx.currentUserRole === 'admin-master')
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _cache[40] || (_cache[40] = _createElementVNode("span", { class: "field-label" }, "Nível de acesso", -1)),
                    _createElementVNode("div", _hoisted_55, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessOptions, (opt) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: opt.value,
                          class: _normalizeClass(["access-card", { selected: _ctx.accountForm.role === opt.value }])
                        }, [
                          _createElementVNode("input", {
                            type: "radio",
                            name: "acc-access",
                            value: opt.value,
                            checked: _ctx.accountForm.role === opt.value,
                            onChange: ($event: any) => (_ctx.updateField('role', opt.value))
                          }, null, 40, _hoisted_56),
                          _createElementVNode("span", _hoisted_57, _toDisplayString(opt.label), 1)
                        ], 2))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.accountForm.isEditing ? 'Nova senha' : 'Senha'), 1),
                (_ctx.accountForm.isEditing)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_61, "deixe em branco para manter a atual"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("input", {
                  id: "acc-password",
                  class: "field-input",
                  value: _ctx.accountForm.password,
                  type: _ctx.showPassword ? 'text' : 'password',
                  placeholder: "mínimo 8 caracteres, 1 número",
                  onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateField('password', ($event.target as HTMLInputElement).value)))
                }, null, 40, _hoisted_63),
                _createElementVNode("button", {
                  class: "password-toggle",
                  type: "button",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                }, [
                  (!_ctx.showPassword)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_64, [...(_cache[41] || (_cache[41] = [
                        _createElementVNode("path", {
                          d: "M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z",
                          stroke: "currentColor",
                          "stroke-width": "1.4"
                        }, null, -1),
                        _createElementVNode("circle", {
                          cx: "8",
                          cy: "8",
                          r: "2",
                          stroke: "currentColor",
                          "stroke-width": "1.4"
                        }, null, -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_65, [...(_cache[42] || (_cache[42] = [
                        _createElementVNode("path", {
                          d: "M1 1l14 14M6.5 6.7A2 2 0 0 0 9.3 9.5M3.7 3.9C2.2 5 1 8 1 8s2.5 5 7 5c1.4 0 2.7-.4 3.8-1M6 2.2C6.6 2.1 7.3 2 8 2c4.5 0 7 5 7 5s-.7 1.5-2 2.8",
                          stroke: "currentColor",
                          "stroke-width": "1.4",
                          "stroke-linecap": "round"
                        }, null, -1)
                      ]))]))
                ])
              ]),
              (_ctx.passwordError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(_ctx.passwordError), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_67, [
            _cache[45] || (_cache[45] = _createElementVNode("legend", { class: "form-section-label" }, "Subordinados", -1)),
            _cache[46] || (_cache[46] = _createElementVNode("p", { class: "section-hint" }, "Usuários que este membro pode visualizar e gerenciar.", -1)),
            (_ctx.filledSubordinates.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filledSubordinates, (username) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: username,
                      class: "sub-chip"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.subordinateLabel(username)) + " ", 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sub-chip-remove",
                        onClick: ($event: any) => (_ctx.removeSubordinate(username))
                      }, "×", 8, _hoisted_69)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.availableSubordinates.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("select", {
                    class: "field-input field-select sub-add-select",
                    onChange: _cache[16] || (_cache[16] = ($event: any) => {_ctx.addSubordinate(($event.target as HTMLSelectElement).value); ($event.target as HTMLSelectElement).value = ''})
                  }, [
                    _cache[44] || (_cache[44] = _createElementVNode("option", { value: "" }, "+ Adicionar subordinado", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableSubordinates, (opt) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: opt.username,
                        value: opt.username
                      }, _toDisplayString(opt.name) + " (@" + _toDisplayString(opt.username) + ") ", 9, _hoisted_71))
                    }), 128))
                  ], 32)
                ]))
              : _createCommentVNode("", true),
            (_ctx.filledSubordinates.length === 0 && _ctx.availableSubordinates.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_72, " Nenhum usuário disponível para adicionar. "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("button", {
              class: "btn-primary-action",
              type: "button",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handleSaveAccount && _ctx.handleSaveAccount(...args)))
            }, _toDisplayString(_ctx.accountForm.isEditing ? 'Salvar alterações' : 'Criar usuário'), 1),
            _createElementVNode("button", {
              class: "btn-ghost-action",
              type: "button",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('close-account-form')))
            }, "Cancelar")
          ]),
          (_ctx.accountError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString(_ctx.accountError), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}